import React, { useMemo } from 'react';
import { ProfileOverlay } from '../ProfileOverlay/ProfileOverlay';
import { useResponsive } from '@app/hooks/useResponsive';
import * as S from './ProfileDropdown.styles';
import { BasePopover } from '@app/components/common/BasePopover/BasePopover';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseAvatar } from '@app/components/common/BaseAvatar/BaseAvatar';
import { readUser } from '@app/services/localStorage.service';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { RootState } from '@app/store/store';
import { getFullBlobUrl } from '@app/utils/blobUrl';

export const ProfileDropdown: React.FC = React.memo(() => {
  const { isTablet } = useResponsive();

  const currentUser = useMemo(() => readUser(), []);
  const avatarUrl = useAppSelector((state: RootState) => state.user.currentUserAvatarUrl);

  const overlayContent = useMemo(() => <ProfileOverlay />, []);

  const displayAvatar = avatarUrl ? getFullBlobUrl(avatarUrl) : undefined;

  return currentUser ? (
    <BasePopover content={overlayContent} trigger="click">
      <S.ProfileDropdownHeader as={BaseRow} gutter={[10, 10]} align="middle">
        <BaseCol>
          <BaseAvatar src={displayAvatar} alt="User" shape="circle" size={40} />
        </BaseCol>
        {isTablet && (
          <BaseCol>
            <span>{`${currentUser.name || currentUser.email}`}</span>
          </BaseCol>
        )}
      </S.ProfileDropdownHeader>
    </BasePopover>
  ) : null;
});
